import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';


import { environment } from '../../environments/environment';
import { Answers } from '../models/answers.model';
import { Product } from '../models/data.model';
import { Answer, Step } from '../models/qa.model';
import { StartupService } from './startup.service';
import { QuestionTypeEnum } from '../models/question-type';
import { Router } from '@angular/router';

@Injectable()
export class QaService {
  public paintedBoard: string;
  public selectedProduct: Product;
  private currentAnswer: Answer;
  public answers: Answers = new Answers();
  private progressSource = new BehaviorSubject<string>('0');
  public progress = this.progressSource.asObservable();

  private animationStateSource = new BehaviorSubject<string>('out');
  public animationState = this.animationStateSource.asObservable();
  constructor(
    private http: HttpClient,
    private startupService: StartupService,
    private router: Router
  ) { }

  getStep(nodeId?: number): Observable<Step> {
    if (nodeId === null) {
      nodeId = 0;
    }

    return this.http.get<Step>(`${environment.apiUrl}/questionStep/${this.startupService.websiteName}/${nodeId}`)
      .catch((error: any) => Observable.throw(/*error.json().error ||*/ 'Server error'));
  }

  getProject() {
    const questionTypeProjectGuid = this.startupService.startupData.QuestionTypes
                                        .find(c => c.Name === QuestionTypeEnum.ProjectType).ItemGuid;
    const selectedAnswers = this.answers.selectedAnswers.find(x => x.QuestionType === questionTypeProjectGuid);
    if (!selectedAnswers) {
      this.router.navigate(['en-us', 'welcome']);
      return;
    }
    return selectedAnswers.Title.toLowerCase();
  }

  public get CurrentAnswer(): Answer {
    return this.currentAnswer;
  }

  public set CurrentAnswer(value: Answer) {
    this.currentAnswer = value;
  }

  setAnimationState(state: string) {
    this.animationStateSource.next(state);
  }

  updateProgress(progress: string) {
    this.progressSource.next(progress);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/qa.service.ts